
import {Heading} from "@chakra-ui/react";


const Header = () => {
    return ( 
        <>
        <Heading mb="8">Todo - List</Heading>
        </>
     );
}
 
export default Header;